<template>
  <div class="impersonation-page d-flex align-center justify-center pa-6">
    <v-card class="pa-8 text-center" max-width="520" width="100%" outlined>
      <template v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
          size="48"
          width="4"
          class="mb-5"
        />
        <div class="text-h6 mb-2">Signing in as user</div>
        <div class="body-2 grey--text text--darken-1">
          Please wait while the secure link is exchanged.
        </div>
      </template>

      <template v-else>
        <v-icon color="error" size="48" class="mb-4">
          mdi-alert-circle-outline
        </v-icon>
        <div class="text-h6 mb-2">Unable to sign in</div>
        <div class="body-2 font-weight-bold mb-1" v-if="errorCode">
          Error code: {{ errorCode }}
        </div>
        <div class="body-2">{{ errorMessage }}</div>
        <div
          class="body-2 grey--text text--darken-1 mt-2"
          v-if="errorDetails"
        >
          {{ errorDetails }}
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: true,
      errorCode: null,
      errorMessage: null,
      errorDetails: null,
    };
  },
  async created() {
    if (this.$route.query.sessionExpired) {
      this.showError(
        "This impersonated session has expired. Ask the superadmin to try again.",
      );
      return;
    }

    const code = this.$route.query.code;

    if (!code) {
      this.showError(
        "This impersonation link is missing or invalid. Ask the superadmin to try again.",
      );
      return;
    }

    try {
      const session = await this.exchangeImpersonationCode(code);
      let destination = "/";

      if (session.userRole === "filistos") {
        destination = "/superadmin";
      } else if (session.userRole === "allpsysup") {
        destination = "/allpsysup";
      }

      await this.$router.replace({ path: destination });
    } catch (e) {
      const error = e.response?.data?.Error || e.response?.data?.error;
      const errorCode =
        error?.errorCode || e.response?.status || e.code || "Unknown";
      const errorMessage =
        error?.errorMessage ||
        e.response?.data?.message ||
        e.message ||
        "Unable to sign in with this impersonation link.";

      this.showError(errorMessage, errorCode, error?.errorDetails);
    }
  },
  methods: {
    ...mapActions(["exchangeImpersonationCode"]),
    showError(message, code = null, details = null) {
      this.errorCode = code;
      this.errorMessage = message;
      this.errorDetails = details;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.impersonation-page {
  min-height: 100vh;
  width: 100%;
}
</style>
